import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import { connect } from 'react-redux';
import _ from 'lodash'
import moment from 'moment'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import Toggle from 'react-toggle'

import { sendDriverQRCode } from '../../action/DriverActions'

import ModalUploadFile from '../../component/common/modals/ModalUploadFile'
import ModalDelete from '../../component/smart/modals/ModalDelete'
import ModalDriverAvatarGallery from './ModalDriverAvatarGallery'
import { checkEmail } from '../../component/helpers/tablesFuncHelpers'
import CustomOverlayTrigger from "../../component/CustomOverlayTrigger"
import { tooltipIcon } from '../../helpers/iconHelpers'
import CustomButton from '../../component/CustomButton'
import { addDriver, uploadDrivers } from "../../action/DriverActions";

const ModalAddAndEditDriver = (props) => {
	const { i18n, t } = useTranslation('translation', { keyPrefix: 'driversPage.modalAddAndEditDriver' });
	const { groups, company, user, deleteDriver, driver, handleDriverEdit, type, closeEdit, setPropStates, isUsingDriverFaceID, toggleLoader } = props;
	const isProd = location.hostname === 'fleet.roscolive.com';
	const tennaPartnerCompanyId = isProd ? 2171 : 7921;

	const [data, setData] = useState({
		first_name: '',
		last_name: '',
		group_id: '',
		card_id: '',
		email: '',
		send_qr_code: false
	});
	const [errMessage, setErrMessage] = useState({
		errfirst_name: '',
		errlast_name: '',
		erremail: '',
		errphone_number: '',
		errcard_id: '',
	});
	const [showAddDriverModal, setShowAddDriverModal] = useState(false);
	const [driverSaved, setDriverSaved] = useState(false);
	const [showUploadDrivers, setShowUploadDrivers] = useState(false);
	const [showAddAvatarsModal, setShowAddAvatarsModal] = useState(false);
	const [showGalleryConfirm, setShowGalleryConfirm] = useState(false);
	const [fileUploadDrivers, setFileUploadDrivers] = useState(null);
	const [upd, setUpd] = useState(false);
	const [bulkUploadQRCode, setBulkUploadQRCode] = useState(false);
	const [galleryPhotos, setGalleryPhotos] = useState(driver?.photos || []);
	const [selectedPhotoIds, setSelectedPhotoIds] = useState([]);
	const [facialRecognitionConsent, setFacialRecognitionConsent] = useState(() => (
		isUsingDriverFaceID && driver ? !!driver.legal_consent : !isUsingDriverFaceID
	));

	useEffect(() => {
		if (type === 'edit') {
			const card = { ...data, ...driver };
			setData(card);
			setGalleryPhotos(driver?.photos || []);
			setSelectedPhotoIds((driver?.photos || []).map(({ id }) => id));
			setFacialRecognitionConsent(!!driver.legal_consent);
			checkForm(card);
		}
	}, []);

	const fillForm = (e) => {
		const { name } = e.target;
		const value = (name === 'phone_number') ? e.target.value.replace(/[^\d]+/g, '') : (name === 'send_qr_code') ? e.target.checked : e.target.value;

		if (name === 'group_id') {
			setData({ ...data, group_id: value, group_name: (!value) ? '' : e.target.options[e.target.selectedIndex].text });
		} else {
			setData({ ...data, [name]: value });
		}

		(name !== 'send_qr_code') && checkForm({ [name]: value });
	};

	const checkForm = (data) => {
		const regExp = /^[-+]?[0-9A-Fa-f]+\.?[0-9A-Fa-f]*?$/;
		let error = false;

		Object.keys(data).forEach((key) => {
			if (typeof data[key] === 'string' && data[key].trim() === '') {
				error = true;
				errMessage[`err${key}`] = t('errEnterYour') + key.replace('_', ' ');
			} else if ((key === "first_name" || key === "last_name") && !/^[a-zA-Z0-9 ]+$/.test(data[key].toString())) {
				error = true;
				errMessage[`err${key}`] = t('errEnterKey') + key;
			} else if (key === 'email' && data.email && !checkEmail(data.email)) {
				error = true;
				errMessage.erremail = t('errEmail');
			} else if (key === "phone_number" && data[key]?.length < 8) {
				error = true;
				errMessage.errphone_number = i18n.t('errorMessage.errPhoneNumberLength');
			} else if (key === "phone_number" && data[key]?.length > 15) {
				error = true;
				errMessage.errphone_number = i18n.t('errorMessage.errPhoneNumber');
			} else if (!isUsingDriverFaceID && key === 'card_id' && data.card_id && (data.card_id.length !== 8 || !regExp.test(data.card_id))) {
				error = true;
				errMessage.errcard_id = t('errCardId');
			} else if (!isUsingDriverFaceID && key === 'send_qr_code' && !data.email && data.send_qr_code) {
				error = true;
				errMessage.erremail = t('errSendQRCode');
			} else if (errMessage[`err${key}`]) {
				errMessage[`err${key}`] = null;
			}
		})

		setErrMessage(errMessage);
		setUpd(!upd);
		return error;
	};

	const onHide = () => {
		setErrMessage({
			errfirst_name: '',
			errlast_name: '',
			erremail: '',
			errphone_number: '',
		});
		(type === "edit") && closeEdit();
		clearFields();
		setShowAddDriverModal(false);
	}

	const originalPhotoIds = (driver?.photos || []).map(({ id }) => id);
	const addedAvatarsCount = selectedPhotoIds.filter(id => !originalPhotoIds.includes(id)).length;
	const removedAvatarsCount = originalPhotoIds.filter(id => !selectedPhotoIds.includes(id)).length;
	const galleryChanged = isUsingDriverFaceID && (addedAvatarsCount > 0 || removedAvatarsCount > 0);

	const saveDriver = () => {
		const error = checkForm(data);

		const changedData = _.reduce(_.keys(data), (result, key) => {
			if (!Object.prototype.hasOwnProperty.call(driver, key) || !_.isEqual(driver[key], data[key])) {
				result[key] = data[key]
			}
			return result;
		}, {});
		if (_.isEmpty(changedData) && !galleryChanged) {
			toastr.warning('', t('driverNoChanges'))
			return
		}

		if (!error) {
			if (+company.company_data?.created_by_company_id !== tennaPartnerCompanyId && isUsingDriverFaceID && !driver.legal_consent && facialRecognitionConsent) {
				changedData.legal_consent = true
			}
			let uiDriverPatch = {};
			if (isUsingDriverFaceID) {
				uiDriverPatch = {
					photos: galleryPhotos,
					driver_gallery_complete: galleryPhotos.length >= 10,
				};
			}
			handleDriverEdit(changedData, null, uiDriverPatch)
			setDriverSaved(true);
		}
	};

	const onSave = () => {
		if (checkForm(data)) {
			return;
		}
		if (galleryChanged) {
			setShowGalleryConfirm(true);
			return;
		}

		saveDriver();
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		const { first_name, last_name, group_id, card_id, email, send_qr_code, phone_number } = data;
		const params = {
			first_name: first_name.trim(),
			last_name: last_name.trim(),
			company_id: company.company_id,
			email
		}
		if (!isUsingDriverFaceID) {
			params.card_id = card_id
		} else {
			params.phone_number = phone_number
			if (+company.company_data?.created_by_company_id !== tennaPartnerCompanyId) {
				params.legal_consent = true
			}
		}
		if (group_id) {
			params.group_id = group_id
		}
		if (send_qr_code) {
			params.send_qr_code = send_qr_code
		}

		const error = checkForm(params, e);
		if (!error) {
			toggleLoader(true);

			addDriver(params)
				.then((res, err) => {
					console.log('handleSubmit res: ', res, err)

					const obj = res.data.response
					setPropStates({
						initialData: [...props.initialData, obj],
						drivers: [...props.drivers, obj],
					})
					clearFields();

					toggleLoader(false);
					setDriverSaved(true);
					onHide();
					toastr.success('', t('driverAdded'))
				})
				.catch((error) => {
					toggleLoader(false);
					console.log('!onSave error: ', error.response, error)
					if (error.response && error.response.status === 404) {
						toastr.error(error.response.data.response.error);
					} else {
						toastr.error(t('unableAddDriver'));
					}
				})
		}
	};

	const clearFields = () => {
		const data = {
			first_name: '',
			last_name: '',
			group_id: '',
			card_id: '',
			email: '',
			send_qr_code: false,
		};

		setData(data);

		setErrMessage({
			errfirst_name: '',
			errlast_name: '',
			erremail: '',
			errphone_number: '',
			errcard_id: '',
		});
	};

	const btnDelete = () => {
		type === "add" ?
			onHide() :
			deleteDriver(driver);
	}

	const sendQRCode = () => {
		if (!data.email) {
			setErrMessage({ ...errMessage, erremail: t('erremail') });
		}
		else if (!data.card_id) {
			setErrMessage({ ...errMessage, errcard_id: t('errcard_id') });
		}
		else if (data.email === driver.email) {
			sendDriverQRCode(data.id)
				.then(res => {
					toastr.success(t('sentQRCode'))
				})
				.catch(err => {
					toastr.error(t('unableSendQRCode'))
				})
			onHide();
		}
		else {
			handleApply(true);
		}
	};

	const displayUploadDrivers = () => {
		setShowUploadDrivers(true);
	};

	const closeUploadDrivers = () => {
		setShowUploadDrivers(false);
	};

	const handleFileChange = (e) => {
		const { value } = e.target;
		const file = e.target.files[0];
		setFileUploadDrivers(file);

		let i;
		if (value.lastIndexOf('\\')) {
			i = value.lastIndexOf('\\') + 1;
		} else {
			i = value.lastIndexOf('/') + 1;
		}
		const filename = value.slice(i);
		const uploaded = document.getElementById('upload-form-label');
		uploaded.innerHTML = filename;
	};

	const handleUploadDrivers = (e) => {
		e.preventDefault()

		if (!fileUploadDrivers) {
			toastr.warning(t('selectCSV/ExcelFile'))
			return
		}

		const params = {
			file: fileUploadDrivers,
			company_id: company.company_id,
			send_qr_code: bulkUploadQRCode,
		}
		toggleLoader(true);
		uploadDrivers(params)
			.then((res, err) => {
				console.log('handleUploadDrivers res: ', res, err)
				toggleLoader(false);
				toastr.success('', t('toastrFileUploaded'))
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('handleUploadDrivers error: ', error.response, error)

				toastr.error(t('unableUploadDrivers'));
			})
	};

	const toogleZoom = (event) => {
		const elem = event.target

		if (elem.classList.contains('zoom')) {
			elem.classList.remove('zoom')
		} else {
			elem.classList.add('zoom')
		}
	}

	const removeAvatar = (photoId) => {
		setGalleryPhotos(galleryPhotos.filter(({ id }) => id !== photoId));
		setSelectedPhotoIds(selectedPhotoIds.filter(id => id !== photoId));
	};

	const openAddAvatarsModal = () => setShowAddAvatarsModal(true);

	const selectAvatars = (selectedPhotos, availableIds) => {
		const photos = _.uniqBy([
			...galleryPhotos.filter(photo => !availableIds.includes(photo.id)),
			...selectedPhotos,
		], 'id');
		setGalleryPhotos(photos);
		setSelectedPhotoIds(photos.map(photo => photo.id));
		setShowAddAvatarsModal(false);
	};

	const { first_name, last_name, phone_number, group_id, email, card_id, send_qr_code } = data;
	const { errfirst_name, errlast_name, errphone_number, erremail, errcard_id } = errMessage;

	return (
		<div className="add-asset-block">
			{(type === "add") && <CustomButton variant="secondary-outline" className='rosco-secondary-inverted' onClick={() => setShowAddDriverModal(true)}>{showAddDriverModal ? t('btnCancel') : driverSaved ? t('btnAddAnotherDriver') : t('btnAddANewDriver')}</CustomButton>}
			{((type === "edit") || showAddDriverModal)
				&& (
					<Modal
						show
						onHide={onHide}
						className="modal-lg-size driver-modal"
					>
						<Modal.Header closeButton>
							<Modal.Title>{type === "add" ? t('titleNewDriver') : t('titleEditDriver')}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className="edit-and-add-driver-modal">
								<div className="driver-form">
									<div className={classnames('inputGroup', { 'has-error': errfirst_name })}>
										<label className="control-label">{t('labelFirstName')}</label>
										<div>
											<input
												type="text"
												name="first_name"
												className="vehicle-search"
												value={first_name || ''}
												onChange={fillForm}
											/>
										</div>
										{errfirst_name && <span className="error-label">{errfirst_name}</span>}
									</div>
									<div className={classnames('inputGroup', { 'has-error': errlast_name })}>
										<label className="control-label">{t('labelLastName')}</label>
										<div>
											<input
												type="text"
												name="last_name"
												className="vehicle-search"
												value={last_name || ''}
												onChange={fillForm}
											/>
										</div>
										{errlast_name && <span className="error-label">{errlast_name}</span>}
									</div>
									{isUsingDriverFaceID &&
										<div className={classnames('inputGroup', { 'has-error': errphone_number })}>
											<label className="control-label">{t('labelPhoneNumber')}</label>
											<div>
												<input
													type="text"
													name="phone_number"
													className="vehicle-search"
													value={phone_number || ''}
													onChange={fillForm}
												/>
											</div>
											{errphone_number && <span className="error-label">{errphone_number}</span>}
										</div>}
									<div className={classnames('inputGroup', { 'has-error': erremail })}>
										<label className="control-label">{t('labelEmail')}</label>
										<div>
											<input
												type="text"
												name="email"
												className="vehicle-search"
												value={email || ''}
												onChange={fillForm}
											/>
										</div>
										{erremail && <span className="error-label">{erremail}</span>}
									</div>
									<div className="inputGroup">
										<label className="control-label">{t('labelGroup')}<span>{t('optional')}</span></label>
										<select
											placeholder={t('placeholderSelectGroup')}
											className="rosco-select block"
											name="group_id"
											value={group_id || ''}
											onChange={fillForm}
										>
											<option value="" disabled>{t('placeholderSelectGroup')}</option>
											{groups.map(({ id, group_name }) => <option key={id} value={id}>{group_name}</option>)}
										</select>
									</div>
									{!isUsingDriverFaceID &&
										<>
											<div className={classnames('inputGroup', { 'has-error': errcard_id })}>
												<label className="control-label">{t('labelCardID')}</label>
												<div>
													<input
														type="text"
														name="card_id"
														className="vehicle-search"
														value={card_id || ''}
														onChange={fillForm}
													/>
												</div>
												{errcard_id && <span className="error-label">{errcard_id}</span>}
											</div>
											{type === 'add' &&
												<div className='toggles-container'>
													<label className='toggle-wrapper'>
														<Toggle
															name="send_qr_code"
															checked={send_qr_code}
															onChange={fillForm}
														/>
														<span className="control-label">
															{t('labelSendQRCode')}
														</span>
													</label>
												</div>}
										</>}
								</div>
								{isUsingDriverFaceID &&
									<div className="facial-recognition-block">
										<div className="titleFacialRecognition">{t('titleFacialRecognition')}</div>
										<div className="status-block">
											{(+company.company_data?.created_by_company_id !== tennaPartnerCompanyId) && (
												<div className="status-row disclaimer">
													<input
														type="checkbox"
														checked={facialRecognitionConsent}
														onChange={(e) => setFacialRecognitionConsent(e.target.checked)}
													/>
													<label className="facial-recognition-consent">
														{t('disclaimerLabel')} <span className="disclaimerText">{t('disclaimerText')}</span>
													</label>
												</div>
											)}
											<div className="status-row">
												<CustomOverlayTrigger
													title={t('titleDriverConsent')}
													body={t('driverStatusDescription')}
													placement="top"
													prefix="info"
													closeBtn={true}
												>
													{tooltipIcon}
												</CustomOverlayTrigger>
												<div className="status-label">{t('status')}{driver?.legal_consent ? <span className="consentGiven">{t('consentGiven')}</span> : <span className="consentNotGiven">{t('consentNotGiven')}</span>}</div>
											</div>
											{(type === "edit" && driver?.legal_consent) &&
												(<div className="status-row">
													<CustomOverlayTrigger
														title={t('titleDriverTrainingImages')}
														body={t('driverImageGalleryDescription')}
														placement="top"
														prefix="info"
														closeBtn={true}
													>
														{tooltipIcon}
													</CustomOverlayTrigger>
													<div className="imageGallery">{t('imageGallery')}<span className={`${driver.driver_gallery_complete ? "complete" : "notComplete"}`}>{`${driver?.photos?.length ? driver.photos.length : 0} / 10` + t('imgCaptured')}</span></div>
												</div>)
											}
										</div>
										<div className="avatars-header">
											<div className="titleFacialRecognition mt-20">{t('availableAvatars')}</div>
											{type === 'edit' &&
												<CustomButton variant="primary-outline" size="hs" onClick={openAddAvatarsModal}>{t('btnAddAvatars')}</CustomButton>}
										</div>
										{galleryPhotos.length > 0 &&
											<div className='avatars-list'>
												{galleryPhotos.map(item =>
													<div key={item.id} className="driver-avatar-wrapper">
														<button type="button" className="remove-avatar" onClick={() => removeAvatar(item.id)}>x</button>
														<img className="driver-avatar" src={item.url ? item.url : "/images/unknown_driver.svg"} alt="Avatar" onClick={toogleZoom} />
													</div>
												)}
											</div>
										}
									</div>}
							</div>
						</Modal.Body>
						<Modal.Footer>
							<CustomButton
								variant="delete"
								onClick={btnDelete}>
								{type === "add" ? t('btnClose') : t('btnDelete')}
							</CustomButton>
							{(type === "edit" && !isUsingDriverFaceID) &&
								<CustomButton
									variant="primary-outline"
									onClick={sendQRCode}>
									{t('btnSendQRCode')}
								</CustomButton>}
							{(type === "add" && !isUsingDriverFaceID) &&
								<CustomButton
									className="rosco-primary-inverted"
									onClick={displayUploadDrivers}
									title={t('titleUploadExcel/CSVFile')}
									variant='primary-outline'
								>
									{t('btnUploadDrivers')}
								</CustomButton>}
							<CustomButton
								variant="primary"
								disabled={!facialRecognitionConsent}
								onClick={(type === "add" ? handleSubmit : onSave)}
							>
								{t('btnSave')}
							</CustomButton>
						</Modal.Footer>
					</Modal>)
			}
			{showUploadDrivers
				&& (
					<ModalUploadFile
						onFileChange={handleFileChange}
						onUploadFile={handleUploadDrivers}
						onHide={closeUploadDrivers}
						btnUploadTitle={t('btnAddNewDrivers')}
					>
						<div className='toggles-container' style={{ marginLeft: '25%' }}>
							<label className='toggle-wrapper'>
								<Toggle
									name="send_qr_code"
									checked={bulkUploadQRCode}
									onChange={(e) => {
										const value = e.target.checked;
										setBulkUploadQRCode(value);
									}}
								/>
								<span className="control-label">{t('labelSendQRCode')}</span>
							</label>
						</div>
					</ModalUploadFile>
				)}
			{showAddAvatarsModal &&
				<ModalDriverAvatarGallery
					driverId={driver.id}
					toggleLoader={toggleLoader}
					selectedPhotoIds={selectedPhotoIds}
					assignedTripPhotoIds={(driver.photos || []).map(photo => photo.driver_trip_photo_id).filter(id => id != null)}
					onCancel={() => setShowAddAvatarsModal(false)}
					onSelect={selectAvatars}
				/>}
			{showGalleryConfirm &&
				<ModalDelete
					title={t('titleConfirmGallery')}
					backdropClassName="custom-modal-backdrop z-index-highest"
					content={t(selectedPhotoIds.length ? 'confirmGalleryChanges' : 'confirmEmptyGallery', { added: addedAvatarsCount, removed: removedAvatarsCount })}
					closeBtnName={t('btnNo')}
					deleteBtnName={t('btnYes')}
					showClose
					styleView="confirm"
					closeModal={() => setShowGalleryConfirm(false)}
					deleteModal={() => {
						setShowGalleryConfirm(false);
						saveDriver();
					}}
				/>}
		</div>
	)
};

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company
	}),
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(ModalAddAndEditDriver);
